module.exports = __webpack_public_path__ + "2026310:ef9a7edf554eddff21f3/img/ApplePodcasts.c8162c0.svg";